module.exports = __webpack_public_path__ + "static/media/rj_result_city1.f9eab27e.png";